const StateJS = require('@steelbreeze/state');
const EventEmitter = require('events').EventEmitter;
const Enum = require('./enums');
const Event = require('./events');

/*
 * Definition for type : TimerJS
 */

function TimerJS(name, root) {
  this.bus = (root === null) ? new EventEmitter() : root.bus;
  this.name = name;
  this.root = (root === null) ? this : root;
  this.ready = false;

  this.build(name);
}

TimerJS.prototype.build = function (session) {
  /* State machine (states and regions) */
  /* Building root component */
  this._statemachine = new StateJS.State('SoftTimer');
  const _initial_TimerJS_SoftTimer = new StateJS.PseudoState('_initial', this._statemachine, StateJS.PseudoStateKind.Initial);
  const TimerJS_SoftTimer_default = new StateJS.State('default', this._statemachine);
  _initial_TimerJS_SoftTimer.to(TimerJS_SoftTimer_default);
  TimerJS_SoftTimer_default.on(Event.Timer_start).when((timer_start) => timer_start.port === 'timer' && timer_start.type === 'timer_start' && (timer_start.time > 0)).effect((timer_start) => {
    this.startTimer(timer_start.id, timer_start.time);
  });
  TimerJS_SoftTimer_default.on(Event.Timer_start).when((timer_start) => timer_start.port === 'timer' && timer_start.type === 'timer_start' && (timer_start.time === 0)).effect((timer_start) => {
    this.bus.emit('timer', new Event.Timer_timeout_TimerMsgs(this.name, 'timer', timer_start.id));
  });
  TimerJS_SoftTimer_default.on(Event.Timer_cancel).when((timer_cancel) => timer_cancel.port === 'timer' && timer_cancel.type === 'timer_cancel').effect((timer_cancel) => {
    this.cancel(timer_cancel.id);
  });
};
TimerJS.prototype.startTimer = function (TimerJS_startTimer_id_var, TimerJS_startTimer_delay_var) {
  if (this.TimerJS_Timeouts_var.has(TimerJS_startTimer_id_var)) {
    this.cancel(TimerJS_startTimer_id_var);
  }

  this.TimerJS_Timeouts_var.set(TimerJS_startTimer_id_var, setTimeout(() => {
    this.bus.emit('timer', new Event.Timer_timeout_TimerMsgs(this.name, 'timer', TimerJS_startTimer_id_var));

    this.TimerJS_Timeouts_var.delete(TimerJS_startTimer_id_var);
  }, TimerJS_startTimer_delay_var));
};

TimerJS.prototype.cancel = function (TimerJS_cancel_id_var) {
  const timeoutId = this.TimerJS_Timeouts_var.get(TimerJS_cancel_id_var);
  if (timeoutId !== undefined) {
    clearTimeout(timeoutId);
    this.TimerJS_Timeouts_var.delete(TimerJS_cancel_id_var);
  }
};

TimerJS.prototype._stop = function () {
  this.root = null;
  this.ready = false;
  this.stopped = true;
};

TimerJS.prototype._delete = function () {
  this._statemachine = null;
  this._SoftTimer_instance = null;
  this.bus.removeAllListeners();
};

TimerJS.prototype._init = function () {
  this._SoftTimer_instance = new StateJS.Instance('SoftTimer_instance', this._statemachine);
  this.ready = true;
};

TimerJS.prototype._receive = function (msg) {
  if (this.ready) {
    this._SoftTimer_instance.evaluate(msg);
  } else if (!this.stopped) {
    setTimeout(() => this._receive(msg), 4);
  }
};

TimerJS.prototype.toString = function () {
  let result = `instance ${this.name}:${this.constructor.name}\n`;
  result += `\n\tTimeouts = ${this.TimerJS_Timeouts_var}`;
  result += '';
  return result;
};

module.exports = TimerJS;
